module.exports = "/images/london-8.jpg";